/*
 *   File : fetch-portfolio-health.js
 *   Author : https://evoqins.com
 *   Description : Fetch portfolio health modal, explains the MF Central steps before the import starts
 *   Integrations : NA
 *   Version : 1.0.0
*/

// *********** React Core ***************//
import { memo } from "react";

// *********** Components ***************//
import { PrimaryButton, SecondaryButton } from "../Buttons";

// *********** Assets ***************//
import BackIcon from "../../Assets/Images/Login/back-icon.svg";
import CloseBtn from "../../Assets/Images/close-btn.svg";
import StepCircle from "../../Assets/Images/new-onboarding/fetch-portfolio/step-circle.svg";

const FETCH_STEPS = [
    { id: 1, text: "PAN, email & mobile number verification" },
    { id: 2, text: "Choose investment types and mutual fund houses data" },
    { id: 3, text: "Upload the generated QR code" },
];

const FetchPortfolioHealthModal = (props) => {

    const step_items = FETCH_STEPS.map((item) => (
        <li className="fetch-health-step position-relative d-flex gap-3" key={item.id}>
            <img src={StepCircle}
                width={24}
                height={24}
                className="flex-shrink-0"
                draggable="false"
                alt="" />
            <div>
                <p className="e-text-waterloo-gray e-primary-font-inter e-font-weight-600 e-font-10 line-height-12px mb-2">
                    STEP {item.id}
                </p>
                <p className="e-text-gunmetal-navy e-primary-font-inter e-font-weight-500 e-font-14 line-height-20px mb-0">
                    {item.text}
                </p>
            </div>
        </li>
    ));

    return (
        <div className="modal fade e-fetch-health-modal e-manage-modal"
            id="fetch-portfolio-health-modal"
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-labelledby="fetch-portfolio-health-title"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content e-bg-lotion e-border-radius-24 e-box-shadow-filter-modal">

                    {/* Header */}
                    <div className="modal-header border-0 justify-content-start gap-3 p-4 pb-3">
                        <h2 id="fetch-portfolio-health-title" className="mb-0 e-text-charleston-green e-alt-font-poppins e-font-weight-600 e-font-18 line-height-32px">
                            Fetch portfolio
                        </h2>
                        <button type="button"
                            className="e-bg-transparent no-border no-outline p-0 cursor-pointer ms-auto"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={props.onClose}>
                            <img src={CloseBtn}
                                width={32}
                                height={32}
                                draggable="false"
                                alt="" />
                        </button>
                    </div>

                    {/* Body */}
                    <div className="modal-body px-4 pt-0 pb-0">
                        <p className="e-text-onyx e-alt-font-poppins e-font-weight-400 e-font-16 line-height-28px margin-12px-bottom">
                            You’ll be securely redirected to Mf Central to fetch your investment data.
                        </p>

                        {/* Steps */}
                        <section className="e-bg-magnolia-blue e-border-radius-16 padding-24px-all mb-3">
                            <h3 className="e-text-charleston-green e-primary-font-inter e-font-weight-600 e-font-16 line-height-24px mb-3">
                                Fetch your portfolio in 3 steps
                            </h3>
                            <ol className="list-unstyled d-flex flex-column gap-4 mb-0">
                                {step_items}
                            </ol>
                        </section>

                        <p className="e-bg-alice-lavender e-border-radius-16 padding-20px-all e-text-charleston-green e-primary-font-inter e-font-weight-500 e-font-13 line-height-19px mb-0">
                            Please upload the QR code you downloaded from mfCentral to view your Mutual Fund Portfolio
                        </p>
                    </div>

                    {/* Actions */}
                    <div className="d-flex gap-3 p-4">
                        <SecondaryButton name="Cancel"
                            dismiss="modal"
                            className="col padding-12px-tb e-bg-lotion e-border-1px-bright-gray e-text-charleston-green"
                            borderRadius="e-border-radius-10"
                            onPress={props.onClose} />
                        <PrimaryButton name="Continue"
                            className="col padding-12px-tb"
                            loading={props.loading}
                            disabled={props.loading}
                            onPress={props.onContinue} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(FetchPortfolioHealthModal);
